/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayCompetitionBody
 */
export interface PayCompetitionBody {
    /**
     * Competition type
     * @type {string}
     * @memberof PayCompetitionBody
     */
    type: PayCompetitionBodyTypeEnum;
    /**
     * Competition ID
     * @type {string}
     * @memberof PayCompetitionBody
     */
    competitionId: string;
    /**
     * Participant/Team ID
     * @type {string}
     * @memberof PayCompetitionBody
     */
    participantId: string;
    /**
     * Stripe payment method ID (required for USD payments)
     * @type {string}
     * @memberof PayCompetitionBody
     */
    paymentMethodId?: string;
}


/**
 * @export
 */
export const PayCompetitionBodyTypeEnum = {
    tournament: 'tournament',
    ladder: 'ladder',
    league: 'league'
} as const;
export type PayCompetitionBodyTypeEnum = typeof PayCompetitionBodyTypeEnum[keyof typeof PayCompetitionBodyTypeEnum];


/**
 * Check if a given object implements the PayCompetitionBody interface.
 */
export function instanceOfPayCompetitionBody(value: object): value is PayCompetitionBody {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('competitionId' in value) || value['competitionId'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    return true;
}

export function PayCompetitionBodyFromJSON(json: any): PayCompetitionBody {
    return PayCompetitionBodyFromJSONTyped(json, false);
}

export function PayCompetitionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayCompetitionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'competitionId': json['competitionId'],
        'participantId': json['participantId'],
        'paymentMethodId': json['paymentMethodId'] == null ? undefined : json['paymentMethodId'],
    };
}

export function PayCompetitionBodyToJSON(json: any): PayCompetitionBody {
    return PayCompetitionBodyToJSONTyped(json, false);
}

export function PayCompetitionBodyToJSONTyped(value?: PayCompetitionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'competitionId': value['competitionId'],
        'participantId': value['participantId'],
        'paymentMethodId': value['paymentMethodId'],
    };
}

